module.exports = __webpack_public_path__ + "img/red_envelope2.3f08ac28.png";